import { render, staticRenderFns } from "./ui-copy-input.vue?vue&type=template&id=44ee0afc&scoped=true&"
import script from "./ui-copy-input.vue?vue&type=script&lang=ts&"
export * from "./ui-copy-input.vue?vue&type=script&lang=ts&"
import style0 from "./ui-copy-input.vue?vue&type=style&index=0&id=44ee0afc&lang=scss&scoped=true&"
import style1 from "./ui-copy-input.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ui-copy-input.vue?vue&type=style&index=2&id=44ee0afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ee0afc",
  null
  
)

export default component.exports